import { HttpService } from '@/infra/http'
import type { TCondicoesDePrecoProduto, TTabelaDePrecoProduto, TTipoAmortizacaoEnum } from '@/types/simulacao'

export type TGetConfiguracoesPrecoResponse = {
  configuracoesPreco: { condicoesDePreco: TCondicoesDePrecoProduto; tabelaDePreco: TTabelaDePrecoProduto }
  bloco: { idExterno: number; nome: string }
  produto: { idExterno: number; nome: string }
}
export class GetConfiguracoesPreco extends HttpService {
  execute = async (
    idExternoProduto: number,
    idExternoBloco: number,
    tipoDeAmortizacao?: TTipoAmortizacaoEnum | null,
  ) => {
    return this.http.get<TGetConfiguracoesPrecoResponse>(
      `/api/v2/Produto/${idExternoProduto}/bloco/${idExternoBloco}/configuracoespreco`,
      { params: { tipoDeAmortizacao } },
    )
  }
}
